import ObjectID from 'bson-objectid';
import moment from 'moment';
import React from 'react'
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { Col, Row } from 'reactstrap';

import './OrderRow.scss';

const OrderRow = props => (
	<li className="order-row py-3">
		<Row className='w-100'>
			<Col xs="12" sm="10" className="d-flex flex-column align-items-start justify-content-center">
				<h6 className="mb-1">Ordine n. {props.id}</h6>
				<p>{'Effettuato il '}
					{moment(ObjectID(props._id).getTimestamp()).format('DD/MM/YYYY')}
				</p>
				<p>{'Da '}
					<Link to={'/artists/' + props.user._id}><strong>{props.user.name}</strong></Link>
				</p>
				{props.transaction && <>
					<p>{'Transazione '}
						<strong>{props.transaction.method === 'card' ? 'Stripe' : 'PayPal'}</strong>
					</p>
					<p>
						{'ID: '}
						<strong>{props.transaction.id}</strong>
					</p>
					<p>Totale: €{Number(props.transaction.total/100).toFixed(2)}</p>
				</>}
			</Col>
		</Row>
	</li>);

export default withRouter(OrderRow);